import Modal from "./_bootstrapModalExtensions";

type OnStartCallback = (event: MouseEvent) => void;
type OnCompleteCallback = (event: MouseEvent, isSuccess: boolean) => void;

export function OnEKEIDRBindSubmitButtonClick(event: MouseEvent,
    caseFileFilingNumberToBind: string,
    binderProcessId: number,
    onStart: OnStartCallback,
    onComplete: OnCompleteCallback) {

    // If there is no filing number, no need to continue
    if (caseFileFilingNumberToBind === "") {
        Modal.showAlertWindow("Nincs megadva ügyirat azonosító!", "Hiba történt", "Bezárás", false);
        return;
    }

    if (onStart && $.isFunction(onStart)) {
        onStart(event);
    }

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EKEIDRBindCaseFile"],
        method: "POST",
        data: { caseFileFilingNumberToBind: caseFileFilingNumberToBind, binderProcessId: binderProcessId },
        success: function (data, textStatus, jqXHR) {
            // Http 200 response
            // Communication OK, the request has been fulfilled or couldn't, due to handled exception
            if (data.success) {
                let grid: ASPxClientGridView = window['EKEIDRAssemblingList'];
                grid.Refresh();
            }
            else {
                Modal.showAlertWindow(data.message, "Hiba történt", "Bezárás", false);
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            Modal.showAlertWindow("Hiba a kérés elküldésekor. Kérjük, töltse újra az oldalt!", "Hiba történt", "Bezárás", false);
        },
        complete: (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.TextStatus) => {
            // We have to enable the button, no matter what the outcome is
            if (onComplete && $.isFunction(onComplete)) {
                onComplete(event, textStatus === "success" && jqXHR.responseJSON.success);
            }
        }
    });
}

export function OnEKEIDRUnBindSubmitButtonClick(event: MouseEvent,
    caseFileFilingNumberToUnBind: string,
    binderProcessId: number,
    isCurrentBinder: boolean,
    onStart: OnStartCallback,
    onComplete: OnCompleteCallback) {

    if (onStart && $.isFunction(onStart)) {
        onStart(event);
    }

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EKEIDRUnBindCaseFile"],
        method: "POST",
        data: { boundCaseFileFilingNumber: caseFileFilingNumberToUnBind, binderCaseFileProcessId: binderProcessId, isCurrentBinder: isCurrentBinder },
        success: function (data, textStatus, jqXHR) {
            // Http 200 response
            // Communication OK, the request has been fulfilled or couldn't, due to handled exception
            if (data.success) {
                let grid: ASPxClientGridView = window['EKEIDRAssemblingList'];
                grid.Refresh();
            }
            else {
                Modal.showAlertWindow(data.message, "Hiba történt", "Bezárás", false);
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            Modal.showAlertWindow("Hiba a kérés elküldésekor. Kérjük, töltse újra az oldalt!", "Hiba történt", "Bezárás", false);
        },
        complete: (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.TextStatus) => {
            // We have to enable the button, no matter what the outcome is
            if (onComplete && $.isFunction(onComplete)) {
                onComplete(event, textStatus === "success");
            }
        }
    });
}

export function OnEKEIDRAttachSubmitButtonClick(event: MouseEvent,
    caseFileFilingNumberToAttach: string,
    actualProcessId: number,
    onStart: OnStartCallback,
    onComplete: OnCompleteCallback) {

    // If there is no filing number, no need to continue
    if (caseFileFilingNumberToAttach === "") {
        Modal.showAlertWindow("Nincs megadva ügyirat azonosító!", "Hiba történt", "Bezárás", false);
        return;
    }

    if (onStart && $.isFunction(onStart)) {
        onStart(event);
    }

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EKEIDRAttachCaseFiles"],
        method: "POST",
        data: { caseFileFilingNumberToAttach: caseFileFilingNumberToAttach, actualProcessId: actualProcessId },
        success: function (data, textStatus, jqXHR) {
            // Http 200 response
            // Communication OK, the request has been fulfilled or couldn't, due to handled exception
            if (data.success) {
                let grid: ASPxClientGridView = window['EKEIDRAssemblingList'];
                grid.Refresh();
            }
            else {
                Modal.showAlertWindow(data.message, "Hiba történt", "Bezárás", false);
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            Modal.showAlertWindow("Hiba a kérés elküldésekor. Kérjük, töltse újra az oldalt!", "Hiba történt", "Bezárás", false);
        },
        complete: (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.TextStatus) => {
            // We have to enable the button, no matter what the outcome is
            if (onComplete && $.isFunction(onComplete)) {
                onComplete(event, textStatus === "success" && jqXHR.responseJSON.success);
            }
        }
    });
}

export function OnEKEIDRDetachSubmitButtonClick(event: MouseEvent,
    caseFileFilingNumberToDetach: string,
    actualProcessId: number,
    onStart: OnStartCallback,
    onComplete: OnCompleteCallback) {

    // If there is no filing number, no need to continue
    if (caseFileFilingNumberToDetach === "") {
        Modal.showAlertWindow("Nincs megadva ügyirat azonosító!", "Hiba történt", "Bezárás", false);
        return;
    }

    if (onStart && $.isFunction(onStart)) {
        onStart(event);
    }

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EKEIDRDetachCaseFiles"],
        method: "POST",
        data: { caseFileFilingNumberToDetach: caseFileFilingNumberToDetach, actualProcessId: actualProcessId },
        success: function (data, textStatus, jqXHR) {
            // Http 200 response
            // Communication OK, the request has been fulfilled or couldn't, due to handled exception
            if (data.success) {
                let grid: ASPxClientGridView = window['EKEIDRAssemblingList'];
                grid.Refresh();
            }
            else {
                Modal.showAlertWindow(data.message, "Hiba történt", "Bezárás", false);
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            Modal.showAlertWindow("Hiba a kérés elküldésekor. Kérjük, töltse újra az oldalt!", "Hiba történt", "Bezárás", false);
        },
        complete: (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.TextStatus) => {
            // We have to enable the button, no matter what the outcome is
            if (onComplete && $.isFunction(onComplete)) {
                onComplete(event, textStatus === "success" && jqXHR.responseJSON.success);
            }
        }
    });
}

export function RemoveEKEIDRIndicator(event: MouseEvent,
    filingNumber: string,
    isProcess: boolean,
    entityId: number,
    code: string,
    displayName: string,
    devExpressGridView: MVCxClientGridView) {

    // gomb letiltás
    $(event.target).closest('.btn.gridaction').attr('disabled', 'disabled');

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EKEIDRDeleteIndicator"],
        method: "POST",
        data: {
            filingNumber: filingNumber,
            isProcess: isProcess,
            code: code,
            displayName: displayName
        },
        success: function (data) {
            if (!data.success) {
                Modal.showAlertWindow(data.message, "Hiba történt", "Bezárás", false);
            }
        },
        error: function (data) {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            Modal.showAlertWindow("Hiba a kérés elküldésekor. Kérjük, töltse újra az oldalt!", "Hiba történt", "Bezárás", false);
        },
        complete: function () {

            // gomb tiltás feloldása, ha megjött a válasz
            $(event.target).closest('.btn.gridaction').removeAttr('disabled');

            // táblázat frissítése
            if (devExpressGridView != undefined) {
                devExpressGridView.PerformCallback({ filingNumber: filingNumber, entityId: entityId, isProcess: isProcess });
            }
        }
    });
}

export function AddEKEIDRIndicator(event: MouseEvent,
    filingNumber: string,
    isProcess: boolean,
    entityId: number,
    code: string,
    displayName: string,
    devExpressGridView: MVCxClientGridView,
    rowClass: string) {

    AnimationRow(event, rowClass);
    // gomb letiltás
    $(event.target).closest('.btn.gridaction').attr('disabled', 'disabled');

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EKEIDRSaveIndicator"],
        method: "POST",
        data: {
            filingNumber: filingNumber,
            isProcess: isProcess,
            code: code,
            displayName: displayName
        },
        success: function (data) {
            if (!data.success) {
                Modal.showAlertWindow(data.message, "Hiba történt", "Bezárás", false);
            }
        },
        error: function (data) {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            Modal.showAlertWindow("Hiba a kérés elküldésekor. Kérjük, töltse újra az oldalt!", "Hiba történt", "Bezárás", false);
        },
        complete: function () {

            // gomb tiltás feloldása, ha megjött a válasz
            $(event.target).closest('.btn.gridaction').removeAttr('disabled');

            // táblázat frissítése
            if (devExpressGridView != undefined) {
                devExpressGridView.PerformCallback({ filingNumber: filingNumber, entityId: entityId, isProcess: isProcess });
            }
        }
    });

}

export function AnimationRow(event: MouseEvent, rowClass: string) {
    var row = $(document.getElementsByClassName(rowClass));

    row.addClass("BlinkerAnimationRow");

    setTimeout(RemoveAnimationClass, 700, row);
}

export function RemoveAnimationClass(row) {
    $(row).removeClass("BlinkerAnimationRow");
}

export function DisplayErrorMessageOnPage(errorDivId: string, hasError: boolean, errorText: string) {

    if (hasError) {
        $(errorDivId).text(errorText);
        $(errorDivId).show();
    } else {
        $(errorDivId).hide();
    }
}

export function CheckIfFilingNumberExistsInEKEIDR(errorDivId: string, filingNumber: string, isMainFiling: boolean) {

    if (filingNumber == null || filingNumber === "") {
        return;
    }

    let filingType: string = isMainFiling ? "ügyirat" : "irat";
    let notFoundErrorText: string = isMainFiling
        ? `Az ${filingType} iktatószáma nem található meg az iktatórendszerben! A gépi iktatásra történő átálláskor így nem lesz automatikusan hozzászerelve az ügyhöz. 
Az "Eljárás általános adatai" lap "Szerkesztés" funkciójával kijavíthatja az ügyirat iktatószámát.`
        : `Az ${filingType} iktatószáma nem található meg az iktatórendszerben! Az "Ikt. szám mód." gomb segítségével kijavíthatja az iktatószámot.`

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.EKEIDRCheckIfFilingNumberExists"],
        method: "POST",
        data: {
            filingNumber: filingNumber,
            isMainFiling: isMainFiling
        },
        success: function (data, textStatus, jqXHR) {
            // Http 200 response
            // Communication OK, the request has been fulfilled or couldn't, due to handled exception
            if (data.success) {
                if (data.result) {
                    // If the filingNumber can be found
                    DisplayErrorMessageOnPage(errorDivId, false, "");
                } else {
                    // If the filingNumber couldn't be found
                    DisplayErrorMessageOnPage(
                        errorDivId,
                        true,
                        notFoundErrorText);
                }
            }
            else {
                // If there was a connection error or an exception
                DisplayErrorMessageOnPage(errorDivId, true, data.message)
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            DisplayErrorMessageOnPage(errorDivId, true, `Hiba történt az ${filingType} iktatószám ellenőrzési kérésének elküldésekor. Az újbóli ellenőrzéshez kérjük, töltse újra az oldalt!`)
        }
    });
}

export function CheckIfFilingBookAndArchiveStorageLocationExists(event: JQuery.TriggeredEvent) {
    event.preventDefault();
    event.stopPropagation();

    var officeId = $(event.target).data('office-id');
    var oufiFieldId = $(event.target).data('oufi-field-id');
    var filingNumberPrefixFieldId = $(event.target).data('filingnumber-prefix-field-id');
    var oufi = $("#" + oufiFieldId).val();
    var filingNumberPrefix = $("#" + filingNumberPrefixFieldId).val();

    $("#errorDiv > div").hide();

    if (oufi == null || oufi === ""
        || filingNumberPrefix == null || filingNumberPrefix === ""
        || officeId == null || officeId == 0) {
        $("#filingbook-availability-check-display-empty-fields").show();
        return;
    }

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.CheckIfFilingBookAndArchiveLocationExists"],
        method: "POST",
        data: {
            officeId: officeId,
            oufi: oufi,
            filingNumberPrefix: filingNumberPrefix
        },
        success: (data, textStatus, jqXHR) => {
            // Http 200 response
            // Communication OK, the request has been fulfilled or couldn't, due to handled exception
            if (data.success) {
                if (data.filingBookExists) {
                    // If the filingBook can be found
                    $("#filingbook-availability-check-display-ok").show();
                } else {
                    // If the filingBook couldn't be found
                    $("#filingbook-availability-check-display-none").show();
                }

                if (data.archiveStorageLocationExists) {
                    // If the archive storage location can be found
                    $("#archive-storage-location-check-display-ok").show();
                } else {
                    // If the archive storage location couldn't be found
                    $("#archive-storage-location-check-display-none").show();
                }
            } else {
                // If there was a connection error or an exception
                $("#filingbook-availability-check-display-backend-exception").text(data.message).show();
            }
        },
        error: () => {
            // If the frontend server threw an exception (e.g. 404, internal server error, etc)
            $("#filingbook-availability-check-display-frontend-exception").show();
        }
    });
}
jQuery(() => {
    $(document).on('click', '#ekeidr-test-button', function (event) {
        CheckIfFilingBookAndArchiveStorageLocationExists(event);
    });
});
